import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import './title-announcer.component.css';

/**
  * A Component that will, in conjunction with a screenreader, read aloud a title for Accessibility purposes when changed
  */
@Component({
    selector: 'ohp-title-announcer',
    templateUrl: './title-announcer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleAnnouncerComponent {
    /**
     * Text, that when changed, will be read aloud by the screen reader
     */
    @Input() public announcement: string;
}
